// extracted by mini-css-extract-plugin
export const accountsTable = "Table__accountsTable__QM8+T";
export const atlasGrotesk = "'AtlasGrotesk'";
export const body = "Table__body__ewFj7";
export const bold = "700";
export const cell = "Table__cell__Hsww6";
export const creditAccountDetails = "Table__creditAccountDetails__Kxq2M";
export const debtsAccountDetails = "Table__debtsAccountDetails__KH65C";
export const down = "Table__down__fOm+w";
export const footer = "Table__footer__+Akt4";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const headerCell = "Table__headerCell__Iqfs+";
export const headerRow = "Table__headerRow__cohB+";
export const headerTitle = "Table__headerTitle__-6x6y";
export const medium = "500";
export const pageSizeSelectorWrapper = "Table__pageSizeSelectorWrapper__HzT-d";
export const paginatorWrapper = "Table__paginatorWrapper__JqI85";
export const pointing = "Table__pointing__DgJGY";
export const regular = "400";
export const responsiveTitle = "Table__responsiveTitle__+Fa4t";
export const responsiveTitleText = "Table__responsiveTitleText__6olOd";
export const row = "Table__row__e8ZaR";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const sortingWrapper = "Table__sortingWrapper__5qiL2";
export const table = "Table__table__3Gf6k";
export const tableInner = "Table__tableInner__wepl7";
export const textCenter = "Table__textCenter__bzIkB";
export const tooltipIconWrapper = "Table__tooltipIconWrapper__YoKae";
export const up = "Table__up__d6Ana";
export const white = "Table__white__36zF2";
export const withHelpText = "Table__withHelpText__DNH2U";